import { ChangeDetectorRef, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, TemplateRef } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-ordem-drop',
  templateUrl: './ordem-drop.component.html',
  styleUrls: ['./ordem-drop.component.scss','../ordem-edit/ordem-edit.component.scss']
})
export class OrdemDropComponent implements OnInit {

  @Input() class: string = '';
  @Input() title: string = '';
  @Input() key: string = '';
  @Input() keyId: string = '';
  @Input() parentFormGroup: FormGroup = null;
  @Input() data: object[] = [];
  @Input() child: string = '';
  @Input() codeKey: string = '';
  @Input() titleKey: string = '';
  @Input() hasMinutes: boolean = false;
  @Input() editMinutes: boolean = false;
  @Output() orderItem = new EventEmitter<any>();
  listItens = [];

  @Input() tmplRef!: TemplateRef<any>; 
  constructor(
      private cdr: ChangeDetectorRef
    ) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.listItens = this.getSelects(changes.data.currentValue);
    }
  }
  
  get getForm(): FormArray {
    return this.parentFormGroup?.get(this.key) as FormArray;
  }

  onOrderItem(e){
    var value = {data:e.item.data,index:e.currentIndex};
    this.orderItem.emit(value);
  }

  setOrdemItem(e, item){
    this.closeItem(item);
    var index = e.id;
    if(e?.id){
      var value = {data:item, index:index - 1};
      this.orderItem.emit(value);
    }
  }

  hasChild(item){
    return item[this.child]?.length > 0 || false;
  }
  getData(formItem) {
    return this.data.find(d => formItem.get(this.keyId).value == d[this.keyId]);
  } 
  getIndexForm(item) {
    return this.getForm?.controls.findIndex(d => d.get(this.keyId).value == item[this.keyId]);
  } 
  getFormItem(item) {
    return this.getForm?.controls.find(d => d.get(this.keyId).value == item[this.keyId]);
  } 
  closeItem(variable){
    variable['show_body'] = false;
  }
  getSelects(value){
    var index = value?.length;
    return Array.from({ length: index }, (_, i) => ({ id: i + 1, label: i + 1  }));
  }
  sortData() {
    return this.data?.sort(function(a, b) {
      const itemA = this.getFormItem(a);
      const itemB = this.getFormItem(b);
      return itemA?.value?.nro_ord - itemB?.value?.nro_ord;
    }.bind(this)); 

  }
  

  sumMinutes(item): number{
    var sum = item.controls['agencyPf']?.value?.reduce(function(a, b){
      return a + (b['minutes'] ?? 0);
    }, 0);
    return sum;

  }
}
